import { connect } from 'react-redux'
import { Link } from 'redux-little-router'
import { shape, string } from 'prop-types'
import React from 'react'
import { buildViewHrefs, determineSelectedView } from '../../selectors'

const ViewLink = (props) => {
  const href = props.hrefs[props.view.toLowerCase()]
  if (props.selectedView === props.view.toLowerCase()) {
    return (
      <Link
        className={`${props.view.toLowerCase()}-link view-link is-open`}
        href={href}
        replaceState
      >
        {props.view}
      </Link>
    )
  }
  return (
    <Link
      className={`${props.view.toLowerCase()}-link view-link`}
      href={href}
      replaceState
    >
      {props.view}
    </Link>
  )
}
ViewLink.propTypes = {
  hrefs: shape({
    tiles: string.isRequired,
    list: string.isRequired,
    map: string.isRequired,
  }).isRequired,
  view: string.isRequired,
}

const mapStateToProps = state => ({
  hrefs: buildViewHrefs(state),
  selectedView: determineSelectedView(state),
})

export default connect(mapStateToProps, {
})(ViewLink)
